/**
 * Specification Ticker – infinite marquee
 */
(function () {
  'use strict';

  function initMarquee(root) {
    const marquee = root.querySelector('[data-st-marquee]');
    if (!marquee || marquee.dataset.stMarqueeReady === 'true') return;

    const track = marquee.querySelector('[data-st-track]');
    if (!track || !track.children.length) return;

    const speed = parseFloat(root.dataset.scrollSpeed) || 40;
    if (marquee.querySelector('.spec-ticker__marquee-inner')) return;

    const inner = document.createElement('div');
    inner.className = 'spec-ticker__marquee-inner';

    const clone = track.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.removeAttribute('data-st-track');

    track.parentNode.insertBefore(inner, track);
    inner.appendChild(track);
    inner.appendChild(clone);

    marquee.dataset.stMarqueeReady = 'true';

    const contentWidth = inner.scrollWidth / 2;
    const duration = Math.max(12, contentWidth / speed);
    root.style.setProperty('--st-marquee-duration', `${duration}s`);
  }

  function initSection(root) {
    if (!root || root.dataset.stInitialized === 'true') return;
    root.dataset.stInitialized = 'true';
    initMarquee(root);
  }

  function initAll() {
    document.querySelectorAll('[data-spec-ticker]').forEach((root) => {
      if (root.querySelector('[data-st-marquee]')) {
        initSection(root);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-spec-ticker]');
    if (root) {
      root.dataset.stInitialized = 'false';
      const marquee = root.querySelector('[data-st-marquee]');
      if (marquee) marquee.dataset.stMarqueeReady = 'false';
      initSection(root);
    }
  });
})();
